export default __webpack_public_path__ + "static/media/research-covid.d71afed3.svg";